
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index5e7tvqndCXDvbCI2mNSwP5nNP4_0mrIMq6fSrViHoDAMeta } from "/vercel/path0/fysio/app/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93tJEx5GoAfNawziEQWpBsb4e2brEERXSk_tvTUTMkgzQMeta } from "/vercel/path0/fysio/app/pages/[...slug].vue?macro=true";
import { default as indexflIr0tMPpF0yBazgIOkPJDOG7YHhW8_hlx1xEyeMm4IMeta } from "/vercel/path0/fysio/app/pages/blog/index.vue?macro=true";
import { default as indexj_NVIEr4HC7vnEoQK_R_45HX7NWegbPQH5QsNXhU0Orj0Meta } from "/vercel/path0/fysio/app/pages/team/index.vue?macro=true";
import { default as indexeWRd2M_452VtqNZ1EGFHrmjbfG3BxdvUbnaqxa45vo_45XoMeta } from "/vercel/path0/fysio/app/pages/contact/index.vue?macro=true";
import { default as cookie_45instellingenfSFvWkR5_UT3CqJKEZYzmiWHw0IFvV0bFsiJ7J4WpvwMeta } from "/vercel/path0/fysio/app/pages/cookie-instellingen.vue?macro=true";
import { default as indexEqqGwxjqAQdEFIBC8xpVwtKBoihfidPOTQydO_45WzdIQMeta } from "/vercel/path0/fysio/app/pages/fysiotherapie/index.vue?macro=true";
import { default as indexrSCmrUkYPgu0ytS6j2Rbk9_J_45WG0dzLzydHOIDPM2QMMeta } from "/vercel/path0/fysio/app/pages/blog/[blogCategory]/index.vue?macro=true";
import { default as _91_46_46_46slug_93sr6MNC2pXmWlpQDpE_zhba9_45QuRMOBf8kXhVVMjgtWEMeta } from "/vercel/path0/fysio/app/pages/blog/[blogCategory]/[...slug].vue?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/fysio/app/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/vercel/path0/fysio/app/pages/[...slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/fysio/app/pages/blog/index.vue")
  },
  {
    name: "team",
    path: "/team",
    component: () => import("/vercel/path0/fysio/app/pages/team/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/vercel/path0/fysio/app/pages/contact/index.vue")
  },
  {
    name: "cookie-instellingen",
    path: "/cookie-instellingen",
    component: () => import("/vercel/path0/fysio/app/pages/cookie-instellingen.vue")
  },
  {
    name: "fysiotherapie",
    path: "/fysiotherapie",
    component: () => import("/vercel/path0/fysio/app/pages/fysiotherapie/index.vue")
  },
  {
    name: "blog-blogCategory",
    path: "/blog/:blogCategory()",
    component: () => import("/vercel/path0/fysio/app/pages/blog/[blogCategory]/index.vue")
  },
  {
    name: "blog-blogCategory-slug",
    path: "/blog/:blogCategory()/:slug(.*)*",
    component: () => import("/vercel/path0/fysio/app/pages/blog/[blogCategory]/[...slug].vue")
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/recensie",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/vacatures",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/begeleid-sporten/small-group-training",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/begeleid-sporten/:pathMatch(.*)",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/sporten",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/frisse-start",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/small-group-training",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/personal-training",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/duo-training",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/begeleid-sporten/fit-de-zomer-in",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/begeleid-sporten/aanmelden-proefles",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/begeleid-sporten/zomerfit-small-group-training",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/begeleid-sporten/personal-training-duo",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/fit/gratis-small-group-training-proefles",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  }
]